//
//  SDKIconSet.ts
//  Supernova SDK
//
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var IconSet;
(function (IconSet) {
    IconSet["checkCircle"] = "CheckCircle";
    IconSet["crossCircle"] = "CrossCircle";
    IconSet["alert"] = "Alert";
})(IconSet || (IconSet = {}));
